<template>
    <div class="wrap">
        <div>
            <div>
                <el-button @click="addConfig" type="primary" icon="el-icon-circle-plus-outline">添加配置</el-button>
            </div>
            <div class="mt20">
                <el-input placeholder="域名/系统全称" class="w300 seekIpt" v-model="keyword" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
            </div>
        </div>
        <div class="mt10">
            <el-table :data="tableData" class="table-div r30 allDown movePoin" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip width="60" label="序号">
                    <template slot-scope="scope">
                        {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="domainName" label="域名" min-width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.domainName?scope.row.domainName:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="fullName" label="系统全称" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.fullName?scope.row.fullName:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="simpleName" label="系统简称" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.simpleName?scope.row.simpleName:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" min-width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime?scope.row.updateTime:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="240">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="info" plain>详情</el-button>
                        <el-button @click="edit(scope.row)" type="warning" plain>编辑</el-button>
                        <el-button @click="del(scope.row)" type="danger" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:20px;"></ybPagination>
            <config-dialog v-if="configDialogVisible" :configData="configData" :config-dialog-visible="configDialogVisible" @closeConfigDialog="closeConfigDialogVisible"></config-dialog>
        </div>
        
    </div>
</template>
<script>
import ybPagination from '@/components/ybPagination'
import ConfigDialog from './homeConfigDialog'
import * as homeConfigApi from '@/api/homeConfig'
export default {
    components: {
        ybPagination,
        ConfigDialog
    },
    data() {
        return {
            keyword: '',
            tableData:[],
            tableLoading: false,
            page: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            configData: {
                type: '',
                appId: ''
            },
            configDialogVisible: false
        }
    },
    methods: {
        // 搜索筛选
        search() {
            this.page.pageNum = 1;
            this.getConfigList();
        },
        getConfigList() {
            this.tableLoading = true;
            let queryParams = {
              keyword: this.keyword,
              pageNum: this.page.pageNum,
              pageSize: this.page.pageSize
            }
            homeConfigApi.getHomeConfigList(queryParams).then(r => {
                if(r.code === 200) {
                    this.tableData = r.data.records;
                    this.page.total = r.data.total;
                    this.tableLoading = false;
                }
            }).catch(e=>{})
        },
        // 添加配置
        addConfig() {
            this.configData.type = 'isAdd';
            this.configDialogVisible = true;
        },
        // 详情
        detail(row) {
            this.configData.type = 'isDetail';
            this.configData.id = row.id;
            this.configData.domainName = row.domainName;
            this.configDialogVisible = true;
        },
        // 编辑
        edit(row) {
            this.detail(row);
            this.configData.type = 'isEdit';
        },
        // 删除
        del(row) {
            this.$confirm('是否确认删除配置? 此操作不可恢复!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                homeConfigApi.delHomeConfig({id: row.id}).then(r => {
                    if (r.code === 200) {
                        this.$message.success('删除成功!')
                    }
                    this.getConfigList();
                })
            }).catch(e => {})
        },
        // 关闭dialog
        closeConfigDialogVisible() {
            this.configDialogVisible = false;
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getConfigList();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getConfigList();
            }
        }
    },
    mounted() {
        this.getConfigList();
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
    }
</style>